<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="10">
            <a-form-item label="项目编号">
              <a-input placeholder="请输入项目编号" v-model="queryParam.projNum"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="10">
            <a-form-item label="项目名称">
              <a-input placeholder="请输入项目名称" v-model="queryParam.name"/>
            </a-form-item>
          </a-col>

          <template v-if="toggleSearchStatus">

            <!-- <a-col :md="5" :sm="8">
              <a-form-item label="项目简称">
                <a-input placeholder="请输入项目简称" v-model="queryParam.shortName"/>
              </a-form-item>
            </a-col> -->
            <a-col :md="4" :sm="6">
              <a-form-item label="项目类型">
                <j-dict-select-tag
                  placeholder="请选择项目类型"
                  v-model="queryParam.type"
                  dictCode="bms_project_type">
                </j-dict-select-tag>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="10">
              <a-form-item label="客户名称">
                <j-search-select-tag type="list" v-model="queryParam.customer"
                  dict="biz_customer,name,id"
                  :async = "true"
                  placeholder="请输入至少两个汉字查询"/>
              </a-form-item>
            </a-col>
            <a-col :md="2" :sm="6">
              <a-form-item label="包含下级">
                <a-checkbox v-model="queryParam.includeSubCustomer">
                </a-checkbox>
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="8">
              <a-form-item label="状态">
                <j-dict-select-tag
                  placeholder="请选择项目状态"
                  v-model="queryParam.status"
                  dictCode="bms_project_status">
                </j-dict-select-tag>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="8">
              <a-form-item label="提交人">
                <j-search-select-tag
                  type="list"
                  placeholder="请选择提交人"
                  v-model="queryParam.committer"
                  dict="sys_user,realname,username,status='1'">
                </j-search-select-tag>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="创建日期">
                <a-range-picker
                  style="width: 220px"
                  v-model="queryParam.createTimeRange"
                  format="YYYY-MM-DD"
                  :placeholder="['开始日期', '结束日期']"
                  @change="onDateChange"
                />
              </a-form-item>
            </a-col>


          </template>

          <a-col :md="4" :sm="10">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'projectInfo:add'">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('项目基本信息表')" v-has="'projectInfo:export'">导出</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
          <a-divider type="vertical"/>

          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay"> <!-- 续保的项目只能编辑，不能删除和提交，直接到风险方案管理步骤 -->
              <a-menu-item v-has="'projectInfo:edit'" v-show="record.status==projectStatus.PLAN_APPLY || record.status== projectStatus.RENEWAL">
                <a v-has="'projectInfo:edit'" @click="handleEdit(record)" >编辑</a>
              </a-menu-item>
              <a-menu-item v-has="'projectInfo:del'" v-show="record.status==projectStatus.PLAN_APPLY">
                <a-popconfirm v-has="'projectInfo:del'" title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-has="'projectInfo:commit'" v-show="record.status== projectStatus.PLAN_APPLY || record.status== projectStatus.PLAN_FAIL">
                <a  @click="handleCommit(record)" >提交审核</a>
              </a-menu-item>
              <a-menu-item v-has="'projectInfo:return'" v-show="record.status==projectStatus.PLAN_AUDIT">
                <a @click="handleAudit(record,projectStatus.PLAN_APPLY)" >退回</a>
              </a-menu-item>
              <a-menu-item v-has="'projectInfo:auditPass'" v-show="record.status==projectStatus.PLAN_AUDIT">
                <a @click="handleAudit(record,projectStatus.INITATION_WAIT)" >审核通过</a>
              </a-menu-item>
              <a-menu-item v-has="'projectInfo:claim'" v-show="record.status== projectStatus.CANCEL">
                <a @click="handleClaim(record)" >认领</a>
              </a-menu-item>

              <a-menu-item v-has="'projectInfo:syncdict'" v-show="record.status==projectStatus.SERVICING"> <!--服务中项目可以同步数据到项目字典-->
                <a v-has="'projectInfo:syncdict'" @click="handleSyncDict(record)" >同步字典</a>
              </a-menu-item>
              <a-menu-item v-has="'projectInfo:renewal'" v-show="(record.status==projectStatus.SERVICING || record.status==projectStatus.END) && (record.renewFlag != '1')"> <!--服务中或结束的项目可以续保-->
                <a v-has="'projectInfo:renewal'" @click="handleRenewal(record)" >续保</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <project-info-modal ref="modalForm" @ok="modalFormOk"></project-info-modal>

    <a-modal v-model="modalVisible" :title="auditRemarkTitle" @ok="handleAuditRemarkOK">
      <label style="margin-bottom: 10px;display: block;">{{auditRemarkTitle}}：</label>
      <a-textarea rows="3" maxlength="255" placeholder="请输入简要描述" v-model="auditRemark" :trigger-change="true" />
    </a-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import { postAction} from '@/api/manage'
  import JDate from '@/components/jeecg/JDate'
  import { mapGetters } from 'vuex'
  import ProjectInfoModal from './modules/ProjectInfoModal'
  import ProjectStatus from '../ProjectStatus'

  export default {
    name: 'ProjectInfoList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JSearchSelectTag,
      JDate,
      ProjectInfoModal,
    },
    data () {
      return {
        description: '项目基本信息列表页面',
        disableMixinCreated: true,
        modalVisible: false,
        projectStatus:{},
        currentRecord: null,
        currentStatus: null,
        auditRemarkTitle: '',
        auditRemark: '',
        tabs: '',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'项目编号',
            className:'column-text',
            dataIndex: 'projNum',
            sorter: true
          },
          {
            title:'项目名称',
            className:"column-text",
            dataIndex: 'name'
          },
          {
            title:'状态',
            className:'column-text',
            dataIndex: "statusName",
          },
          {
            title:'项目组',
            className:"column-text",
            dataIndex: 'projectGroup_dictText'
          },
          {
            title:'客户名称',
            className:"column-text",
            dataIndex: 'customerName'
          },
          {
            title:'项目类型',
            className:'column-text',
            dataIndex: 'typeName'
          },
          {
            title:'客户来源渠道',
            className:"column-text",
            dataIndex: 'customerSourceTypeName',
          },
          {
            title:'单位性质',
            className:"column-text",
            dataIndex: 'customerTypeName',
          },
          // {
          //   title:'单位注册地址',
          //   className:"column-text",
          //   dataIndex: 'customerRegisterAddress'
          // },
          {
            title:'预估保费',
            className:"column-money",
            dataIndex: 'customerCostBudget'
          },
          {
            title:'创建人',
            className:'column-text',
            dataIndex: 'createByName',
          },
          {
            title:'创建时间',
            className:'column-text',
            dataIndex: 'createTime'
          },
          {
            title:'提交人',
            className:'column-text',
            dataIndex: 'committerName',
          },
          {
            title:'提交时间',
            className:'column-text',
            dataIndex: 'commitTime'
          },
          {
            title:'审核人',
            className:'column-text',
            dataIndex: 'auditorName',
          },
          {
            title:'审核时间',
            className:'column-text',
            dataIndex: 'auditTime'
          },
          {
            title:'撤销时间',
            className:'column-text',
            dataIndex: 'cancelTime'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:120,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/project/baseInfo/list",
          delete: "/project/baseInfo/delete",
          commit: "/project/baseInfo/commit",
          audit: "/project/baseInfo/audit",
          claim: "/project/baseInfo/claim",
          syncDict:"/project/baseInfo/syncDict",
          exportXlsUrl: "/project/baseInfo/exportXls",
        },
      }
    },
    created() {
      this.projectStatus = ProjectStatus
    },
    methods: {
      ...mapGetters(["userInfo"]),

      onDateChange: function (value, dateString) {
        if(dateString.length >0 && dateString[0].length>0) {
          this.queryParam.createTimeRange = dateString
        } else {
          this.queryParam.createTimeRange = null
        }
      },
      getQueryParams() {
        var param = Object.assign({}, this.queryParam, this.isorter ,this.filters)
        // 创建日期
        if(param.createTimeRange){
          param.createTimeBegin = param.createTimeRange[0] + ' 00:00:00'
          param.createTimeEnd = param.createTimeRange[1] + ' 23:59:59'
          delete param.createTimeRange
        }

        param.pageNo = this.ipagination.current
        param.pageSize = this.ipagination.pageSize
        return filterObj(param);
      },

      // 提交审核基本信息
      handleCommit(record){
        postAction(this.url.commit,{id: record.id}).then(res =>{
          if(res.success){
            this.$message.success("提交完成")
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        })
      },

      // 审核通过、退回
      handleAudit(record, status){
        this.auditRemark=''
        this.currentRecord = record
        this.currentStatus = status

        if(status === this.projectStatus.PLAN_APPLY){ // 退回
          this.auditRemarkTitle ='退回原因'
          this.modalVisible = true
        } else if(status === this.projectStatus.INITATION_WAIT){ // 审核通过
          this.audit()
        }
      },

      // 审核弹窗确认按钮事件
      handleAuditRemarkOK(){
        if(this.auditRemark.length<=0){
          this.$message.warn(this.auditRemarkTitle + "不能为空")
          return
        } else if(this.auditRemark.length >255){
          this.$message.warn(this.auditRemarkTitle + "长度不能超过255个字符")
          return
        }
        this.modalVisible = false;
        this.audit()
      },

      audit(){
        let record = this.currentRecord
        let status = this.currentStatus

        // 审核申请
        let param = {id: record.id, status: status,auditRemark: this.auditRemark}
        postAction(this.url.audit, param).then(res =>{
          if(res.success){
            this.$message.success("操作成功")
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        })
      },

      // 认领撤销状态的申请
      handleClaim(record){
        let param = {id: record.id}
        postAction(this.url.claim, param).then(res =>{
          if(res.success){
            this.$message.success("认领成功")
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        })
      },

      // 同步字典到项目字典和项目简称配置
      handleSyncDict(record){
        postAction(this.url.syncDict,{id: record.id}).then((res)=>{
          if(res.success){
            this.$message.info("项目字典同步成功")
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        })
      },

      // 续保
      handleRenewal(record){
        this.$refs.modalForm.renewal(record);
        this.$refs.modalForm.title = "续保";
        this.$refs.modalForm.disableSubmit = false;
        /*postAction(this.url.renewal,{id: record.id}).then((res)=>{
          if(res.success){
            this.$message.info("项目续保成功")
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        })*/
      },


    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>